"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseSelect = void 0;

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var state_1 = require("../state");

var hooks_1 = require("../hooks");

var Select_styles_1 = require("./Select.styles");

var BaseSelect = function (_a) {
  var id = _a.id,
      children = _a.children,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b,
      className = _a.className,
      label = _a.label,
      style = _a.style,
      error = _a.error,
      caption = _a.caption,
      _c = _a.testId,
      testId = _c === void 0 ? 'Select' : _c,
      forwardedRef = _a.forwardedRef,
      _d = _a.displayValueTransform,
      displayValueTransform = _d === void 0 ? function (f) {
    return f;
  } : _d;

  var _e = react_1.useContext(state_1.SelectContext),
      isExpanded = _e.isExpanded,
      setIsExpanded = _e.setIsExpanded,
      selectedValue = _e.selectedValue;

  var classNames = classnames_1.default({
    'is-expanded': isExpanded,
    'has-selection': selectedValue,
    'is-disabled': disabled,
    'has-error': error
  });
  var labelId = id + "_label";
  var selectedValueId = id + "_selected";
  var listId = id + "_list";
  var ownRef = react_1.useRef(null);
  var buttonRef = forwardedRef || ownRef;
  var listRef = react_1.useRef(null);
  var keyboardEvents = hooks_1.useKeyboardEvents({
    initRef: buttonRef,
    listRef: listRef,
    children: children,
    context: state_1.SelectContext
  });

  var collapse = function () {
    return isExpanded && setIsExpanded(false);
  };

  var outsideClickRef = hooks_1.useOutsideClickRef(collapse);

  var handleOnClick = function () {
    var _a;

    (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    setIsExpanded(!isExpanded);
  };

  react_1.useEffect(function () {
    var _a;

    if (isExpanded) {
      var elemId = id + "_" + selectedValue;
      var offset = (_a = document.getElementById(elemId)) === null || _a === void 0 ? void 0 : _a.offsetTop;
      var listEl = listRef.current;

      if (listEl && typeof offset !== 'undefined') {
        listEl.scrollTo({
          top: offset,
          behavior: 'smooth'
        });
      }
    }
  }, [selectedValue]);

  var disableUpArrowScroll = function (event) {
    var key = event.key;

    if (key === 'ArrowUp') {
      event.preventDefault();
    }
  };

  return react_1.default.createElement(Select_styles_1.SelectWrapper, {
    ref: outsideClickRef,
    style: __assign({}, style),
    className: className,
    onKeyUp: keyboardEvents,
    onKeyDown: disableUpArrowScroll,
    "data-testid": testId
  }, react_1.default.createElement(Select_styles_1.SelectInput, __assign({
    onClick: handleOnClick,
    "aria-haspopup": "listbox",
    "aria-labelledby": labelId + " " + selectedValueId,
    id: id,
    ref: buttonRef,
    className: classNames,
    type: "button"
  }, isExpanded && {
    'aria-expanded': true
  }), react_1.default.createElement("div", null, react_1.default.createElement("div", {
    id: labelId,
    className: "select__label"
  }, label), react_1.default.createElement("span", {
    id: selectedValueId,
    className: "select__inputValue"
  }, displayValueTransform(selectedValue))), isExpanded ? react_1.default.createElement(Select_styles_1.CaretUp, null) : react_1.default.createElement(Select_styles_1.CaretDown, {
    disabled: disabled
  })), caption && react_1.default.createElement(Select_styles_1.SelectCaption, null, caption), error && react_1.default.createElement(Select_styles_1.SelectCaption, {
    className: "has-error"
  }, error), react_1.default.createElement(Select_styles_1.OptionsContainer, __assign({
    role: "listbox",
    className: classNames,
    "aria-labelledby": labelId,
    id: listId
  }, isExpanded && selectedValue && {
    'aria-activedescendant': id + "_" + selectedValue
  }, {
    tabIndex: -1,
    ref: listRef
  }), children));
};

exports.BaseSelect = BaseSelect;
exports.default = react_1.forwardRef(function (props, ref) {
  var onChange = props.onChange,
      value = props.value,
      restProps = __rest(props, ["onChange", "value"]);

  var id = props.id;
  return react_1.default.createElement(state_1.SelectProvider, {
    menuId: id,
    selectedValue: value,
    onChange: onChange
  }, react_1.default.createElement(exports.BaseSelect, __assign({
    forwardedRef: ref
  }, restProps)));
});